import CrudService from "./crud-service";

export default new CrudService("users");
